import { format } from 'date-fns';
/**
 * Formats a date object to `yyyy-MM-dd`
 * @param date
 */
const formatDateObjectToString = (date) => {
    return format(date, 'yyyy-MM-dd');
};
export default formatDateObjectToString;
